export const blockIconsAudioandvideoVideocam = (
	<span className='material-symbols-outlined'>videocam</span>
);
